<template>
    <div>
        <div>
            <div class="row" v-if="!message">
                <div class="col-xs-9 p-0">
                    <button @click="openRoommateMessageModal()" class="btn btn btn-block btn-success waves-effect waves-light">Falar com {{ user.first_name }}</button>
                </div>
                <div class="col-xs-3 p-0">
                    <button @click="openPhoneModal()" id="mbl_btn_contact_phone" class="btn btn btn-block btn-custom waves-effect waves-light"><i class="fas fa-phone"></i></button>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-xs-12">
                    <a :href="'/mensagens/' + user.id" id="mbl_bt_message" class="btn btn btn-block btn-custom waves-effect waves-light"><i class="fas fa-envelope text-white m-r-5"></i> Ver conversa com {{ user.first_name }} </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'online',
            'fk_roommate',
            'invitation',
            'rent_price',
            'ic_amount',
            'view_phone_amount',
            'user',
            'premium_host'
        ],
        data() {
            return {
                message: this.invitation,
                authenticated: window.isAuthenticated,
            }
        },
        created () {
            EventBus.$on('update-message-sent', () => {
                this.message = true;
            });

            EventBus.$on('message_sent', () => {
                this.message = true;
            });
        },
        methods: {
            openPhoneModal() {
                if (!this.authenticated) {
                    EventBus.$emit('open-modal', 'register-modal');
                    window.dataLayer.push({
                        'event': 'show_login_modal',
                        'event_category': 'roommate_ad_page',
                        'event_label': 'show_phone',
                    });
                    return false;
                }

                EventBus.$emit('open-modal', 'phone-block-modal', {
                    name: this.user.first_name,
                    type: 'roommate_ad_page',
                    fk_user: this.user.id,
                    active_premium: this.premium_host,
                    view_phone_amount: this.view_phone_amount
                })
            },
            openRoommateMessageModal() {
                if (!this.authenticated) {
                    EventBus.$emit('open-modal', 'register-modal');
                    window.dataLayer.push({
                        'event': 'show_login_modal',
                        'event_category': 'roommate_ad_page',
                        'event_label': 'send_message',
                    });
                    return false;
                }

                EventBus.$emit('open-modal', 'mobile-invitation-form', {
                    name: this.user.first_name,
                    photo: this.user.photo_url,
                    fk_user: this.user.id,
                    online: this.online,
                    response_rate: this.user.response_rate,
                    last_activity: this.user.last_activity,
                    verified: this.user.verified_account,
                    authenticated: this.authenticated,
                    fk_roommate: this.fk_roommate,
                    ic_amount: this.ic_amount,
                    premium_host: this.premium_host
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mbl_btn_contact_phone {
        padding-right: 25%;
    }
</style>
